import React, { useState } from "react";
import { RefreshCw, Eraser, Video, CalendarDays } from "lucide-react";

// Barra secondaria sotto la barra principale (colonna di sinistra sul web): scorciatoie rapide.
// I tasti "lavoro" (Aggiorna, Svuota cache) si animano finché l'operazione non è finita (min. 0,8 s).
// Etichetta del tasto rapido: durante l'azione mostra lo stato, altrimenti la prima parola dell'etichetta
function testoTasto(attivo, id, label) {
  if (!attivo) return label.split(" ")[0];
  return id === "quick-refresh" ? "Aggiorno…" : "Svuoto…";
}

export default function QuickBar({ onRefresh, onClearCache, onVideoCall, onCalendar, refreshing }) {
  const [busy, setBusy] = useState({});

  const esegui = (id, fn) => async () => {
    if (busy[id]) return;
    setBusy((b) => ({ ...b, [id]: true }));
    const t0 = Date.now();
    try {
      await Promise.resolve(fn?.());
    } finally {
      setTimeout(() => setBusy((b) => ({ ...b, [id]: false })), Math.max(0, 800 - (Date.now() - t0)));
    }
  };

  const voci = [
    ["quick-refresh", "Aggiorna posta", RefreshCw, esegui("quick-refresh", onRefresh), busy["quick-refresh"] || refreshing, "spin-icon"],
    ["quick-clear-cache", "Svuota cache e ricarica", Eraser, esegui("quick-clear-cache", onClearCache), busy["quick-clear-cache"], "wipe-icon"],
    ["quick-videocall", "Videocall", Video, onVideoCall, false, ""],
    ["quick-calendar", "Calendario", CalendarDays, onCalendar, false, ""],
  ];
  return (
    <div className="quickbar" data-testid="quickbar">
      {voci.map(([id, label, Icon, fn, attivo, anim]) => (
        <button
          key={id}
          className={`quickbar-btn ${attivo ? "working" : ""}`}
          title={label}
          aria-label={label}
          aria-busy={attivo || undefined}
          onClick={fn}
          data-testid={id}
        >
          <Icon size={20} strokeWidth={2.4} className={attivo ? anim : ""} />
          <span>{testoTasto(attivo, id, label)}</span>
        </button>
      ))}
    </div>
  );
}
